import React, { Component, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BaseLayout from '../layouts/BaseLayout';
import AccountStructure from '../pages/AccountStructure';
import EntitiesAndScenario from '../pages/EntitiesAndScenario';
import BusinessCase from '../pages/BusinessCase';
import BusinessCases from '../pages/BusinessCases';
import Reporting from '../pages/Reporting';
import Settings from '../pages/Settings';
import Import from '../pages/Import';
import Export from '../pages/Export';
import ExportConfig from '../pages/Export/config';
import Allocations from '../pages/Allocations';
import AuthCallback from '../pages/AuthCallBack/index'; 

class Router extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/auth" element={<AuthCallback />} />
                    <Route path="/">
                        <Route element={<BaseLayout />}>
                            <Route index element={<EntitiesAndScenario />} />
                            <Route path="/entities/:key" element={<BusinessCase />} />
                        </Route>
                    </Route>
                    <Route path="/accountstructure">
                        <Route element={<BaseLayout />}>
                            <Route index element={<AccountStructure />} />
                        </Route>
                    </Route>
                    <Route path="/business-cases">
                        <Route element={<BaseLayout />}>
                            <Route index element={<BusinessCases />} />
                        </Route>
                    </Route>
                    <Route path="/reporting">
                        <Route element={<BaseLayout />}>
                            <Route index element={<Reporting />} />
                        </Route>
                    </Route>
                    <Route path="#1">
                        <Route element={<BaseLayout />}></Route>
                    </Route>
                    <Route path="#2">
                        <Route element={<BaseLayout />}></Route>
                    </Route>
                    <Route path="/import">
                        <Route element={<BaseLayout />}>
                            <Route index element={<Import />} />
                        </Route>
                    </Route>
                    <Route path="/export">
                        <Route element={<BaseLayout />}>
                            <Route index element={<Export />} />
                        </Route>
                    </Route>
                    <Route path="/export/config">
                        <Route element={<BaseLayout />}>
                            <Route index element={<ExportConfig />} />
                        </Route>
                    </Route>
                    <Route path="/allocations">
                        <Route element={<BaseLayout />}>
                            <Route index element={<Allocations />} />
                        </Route>
                    </Route>
                    <Route path="/settings">
                        <Route element={<BaseLayout />}>
                            <Route index element={<Settings />} />
                        </Route>
                    </Route>
                   
                </Routes>
            </BrowserRouter>
        );
    }
}

export default Router;
